export enum EditPaymentDialogType {
  ACTIVATION = 'ACTIVATION',
  PAYMENTCONTRACT = 'PAYMENTCONTRACT',
  ACTIVATIONRESULT = 'ACTIVATIONRESULT',
  PAYMENTTYPE = 'PAYMENTTYPE',
  BANKACCOUNT = 'BANKACCOUNT',
  PAYOUTDETAILS = 'PAYOUTDETAILS',
  EMAILNOTIFICATION = 'EMAILNOTIFICATION',
}
